import { Create, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { HttpError } from "@pankod/refine-core";
import { useEffect } from "react";

const schema = Yup.object({
  tag_action_id: Yup.number(),
  condition_action: Yup.string().required(),
  expired_at: Yup.date()
    .nullable()
    .optional()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  max_received: Yup.number()
    .nullable()
    .optional()
    .transform((curr, orig) => (orig === "" ? null : curr)),
  name: Yup.string().optional(),
  tag_reward_id: Yup.number().optional(),
});

type Schema = Yup.InferType<typeof schema>;

function formatDate(date: Date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-based
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export const TagActionEdit = () => {
  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
    getValues,
    setValue,
  } = useForm<Schema, HttpError, Schema>({ resolver: yupResolver(schema) });

  useEffect(() => {
    if (formLoading === false) {
      const v = getValues("expired_at");

      if (v) {
        const d = new Date(v);
        setValue("expired_at", formatDate(d) as any);
      }
    }
  }, [getValues, formLoading, setValue]);

  return (
    <Create isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tag_action_id")}
          error={!!errors.tag_action_id}
          helperText={errors.tag_action_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tag Action Id"
          disabled
        />
        <TextField
          {...register("name")}
          error={!!errors.name}
          helperText={errors.name?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Name"
          disabled
        />
        <TextField
          {...register("condition_action")}
          required
          error={!!errors.condition_action}
          helperText={errors.condition_action?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Condition Action"
          disabled
        />
        <TextField
          {...register("tag_reward_id")}
          error={!!errors.tag_reward_id}
          helperText={errors.tag_reward_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="text"
          label="Tag Reward Id"
          disabled
        />
        <TextField
          {...register("max_received")}
          error={!!errors.max_received}
          helperText={errors.max_received?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Max Received"
          placeholder="No limit"
          disabled
        />
        <TextField
          {...register("expired_at")}
          error={!!(errors as any)?.expired_at}
          helperText={(errors as any)?.expired_at?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="datetime-local"
          label="Expired At (local)"
        />
      </Box>
    </Create>
  );
};
